export default __webpack_public_path__ + "static/media/logoPequenaCinza.e8d2b5cd.svg";